import { render } from "./Loader.vue?vue&type=template&id=140fe61a&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=140fe61a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-140fe61a"

export default script